export const API_PATH = '/rest/api/3/application-properties';
